export default __webpack_public_path__ + "static/media/9.70edf0d6.svg";